/**
 * Tab 面板内容延后挂载。
 *
 * 非当前 Tab 的商品网格放在 <template> 里，浏览器不会请求其中的图片。
 * 首次切到该 Tab 时把内容搬进面板，之后交互与直接渲染完全一致。
 *
 * 时序说明：TabsComponent.setActiveTab 会先同步派发 tabChange，
 * 面板的显示动画与 grid-list.showGridItems() 在约 300ms 后才执行，
 * 因此在 tabChange 里挂载内容一定早于它们。
 */
(function () {
  'use strict';

  const CONTAINER_SELECTOR = '[data-tp-deferred-tabs]';
  const TEMPLATE_SELECTOR = 'template[data-tp-tab-content]';

  function mountPanel(panel) {
    if (!panel || !panel.querySelector) return;

    const template = panel.querySelector(TEMPLATE_SELECTOR);
    if (!template) return;

    // 直接搬运节点而不是克隆，避免多留一份重复的 DOM。
    panel.appendChild(template.content);
    template.remove();

    if (window.TPImage && typeof window.TPImage.observe === 'function') {
      window.TPImage.observe(panel);
    }
  }

  function init(root) {
    const scope = root || document;
    if (!scope.querySelectorAll) return;

    scope.querySelectorAll(CONTAINER_SELECTOR).forEach(function (tabs) {
      if (tabs.dataset.tpDeferredTabsReady === 'true') return;
      tabs.dataset.tpDeferredTabsReady = 'true';

      tabs.addEventListener('tabChange', function (event) {
        mountPanel(event.detail && event.detail.selectedTab);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
